import { formatBatchDisplayLabel } from '../batch/batchDisplayLabel';

/** Display helpers for batch rows in selects (SRP: presentation strings). */

export function formatBatchSelectLabel(batch) {
  return formatBatchDisplayLabel(batch);
}

export function formatEnrollmentSelectLabel(enrollment) {
  if (!enrollment) return '';
  const batchName = enrollment.batch?.batchName || 'Batch';
  const courseName = enrollment.batch?.course?.courseName || 'Course';
  const status = enrollment.batchStatus || '—';
  return `${batchName} — ${courseName} (${status})`;
}
